<template>
  <div
    class="input-date input-text input-text--with-unit"
    :class="{'input-text--error': error}"
  >
    <DatePicker
      v-bind="$attrs"
      :id="id"
      input-class="input-text__input"
      calendar-class="input-date__calendar"
      v-model="localValue"
      :language="localizations[language]"
      autocomplete="off"
    />
    <button
      v-if="value"
      class="input-date__clear input-text__unit"
      @click="$emit('input', null)"
    >
     <ExIcon />
    </button>
  </div>
</template>

<script>
  import {DateTime} from 'luxon';
  import DatePicker from 'vuejs-datepicker';
  import {fi, en, sv} from 'vuejs-datepicker/dist/locale';

  import globals from '../../lib/globals';
  import ExIcon from '../icons/ExIcon.vue';

  export default {
    components: {
    DatePicker,
    ExIcon
},
    data() {
      return {
        localizations: {
          fi,
          en,
          sv,
        },
        language: globals.language,
      }
    },
    props: {
      id: {
        type: String,
        default: null,
      },
      value: {
        type: String, // yyyy-mm-dd
        default: null,
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      localValue: {
        get () {
          return this.value && DateTime.fromISO(this.value).toJSDate();
        },
        set (newValue) {
          this.$emit('input', DateTime.fromJSDate(newValue).toISODate());
        }
      },
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-date {
  }

  .input-date__calendar {
    @include card;
    margin-top: r(4);
  }

  .input-date__clear {
    @include reset-button(true);
    transition: transform 0.2s;

    &:focus {
      transform: scale(1.2);
    }
  }
</style>
